<header
    website-header-v2
    [websiteSticky]="!(headerService.state$ | async)?.disableStickiness"
    [stickySlot]="stickySlot"
    (isStuckChange)="headerComponent.onStickyChange($event)"
    (hasShadowChange)="headerComponent.onShadowChange($event)"
    [currentLocale]="currentLocale"
    [languages]="(urlLocaliseService.currentLocalisedLinks$ | async) ?? []"
    [primaryNavigation]="primaryNavigation"
    [secondaryNavigation]="secondaryNavigation"
    [headerTheme]="headerViewService.theme$ | async"
    class="header"
    #headerComponent="websiteHeaderV2"
></header>
